import { PromoDetail } from "@/core/entities/promotion/PromoDetail";
import { atom } from "jotai";

export enum PromoProgramEditMode {
  DETAILS = "details",
}

export interface PromoDetailState {
  promoDetail: PromoDetail | null;
  isLoading: boolean;
  isTransitioning: boolean;
  isUpdating: boolean;
  isCreating: boolean;
  editMode: PromoProgramEditMode | null;
  error: Error | null;
}

const initialState: PromoDetailState = {
  promoDetail: null,
  isLoading: false,
  isTransitioning: false,
  isUpdating: false,
  isCreating: false,
  editMode: null,
  error: null,
};

export const promoDetailAtom = atom<PromoDetailState>(initialState);

export const promoDetailDataAtom = atom(get => get(promoDetailAtom).promoDetail);
export const promoDetailIsLoadingAtom = atom(get => get(promoDetailAtom).isLoading);
export const promoDetailIsTransitioningAtom = atom(get => get(promoDetailAtom).isTransitioning);
export const promoDetailIsUpdatingAtom = atom(get => get(promoDetailAtom).isUpdating);
export const promoDetailIsCreatingAtom = atom(get => get(promoDetailAtom).isCreating);
export const promoProgramEditModeAtom = atom(get => get(promoDetailAtom).editMode);
export const promoDetailErrorAtom = atom(get => get(promoDetailAtom).error);
